import { useEffect } from 'react';

// Hook to preload images for better UX - COMPLETELY STABLE
export function useImagePreloader(imageUrls: string[], enabled: boolean = true) {
  useEffect(() => {
    // Always same execution path - no conditional hooks
    if (!enabled || !imageUrls || imageUrls.length === 0) return;

    const preloadPromises = imageUrls.slice(0, 5).map(url => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = url;
      });
    });

    // Preload first 5 images silently
    Promise.allSettled(preloadPromises).then(results => {
      const loaded = results.filter(r => r.status === 'fulfilled').length;
      if (loaded > 0) {
        console.log(`🖼️ Preloaded ${loaded}/${imageUrls.slice(0, 5).length} images`);
      }
    });
  }, [enabled, imageUrls?.length]); // Simple, stable dependencies
}

// Hook to prefetch property details for visible properties
export function usePrefetchPropertyDetails(propertyIds: string[], enabled: boolean = true) {
  useEffect(() => {
    if (!enabled || !propertyIds.length) return;

    // Prefetch first 3 visible properties in background
    propertyIds.slice(0, 3).forEach(id => {
      fetch(`/api/properties/${id}/details`, { 
        // Use no-cache to ensure we get fresh data if available
        cache: 'no-cache' 
      }).catch(() => {
        // Silent fail - this is just prefetching
      });
    });
  }, [propertyIds, enabled]);
}